import { useEffect } from "react";
import { useMediaQuery } from "@/hooks/useMediaQuery";

/**
 * Syncs the `dark` class on <html> with the user's system preference.
 * Also updates the CSS custom property --page-bg so overscroll areas
 * always match the current theme without inline style conflicts.
 */
export function useSystemTheme() {
  const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");

  useEffect(() => {
    const html = document.documentElement;
    html.classList.toggle("dark", prefersDark);

    // Clear any stale inline bg from useThemeColor so CSS takes over
    html.style.removeProperty("background-color");

    // Update meta theme-color to match
    const fallback = prefersDark ? "#110f18" : "#fcfbfd";
    document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')
      .forEach((m) => m.setAttribute("content", fallback));
  }, [prefersDark]);

  return prefersDark;
}
